/**
 * Server is the single source of truth for hotel result order (pinned / internal / rest).
 * Rows from /searchHotels carry `_hr_sort_index` from services/hotel_priority_rules.py.
 *
 * The client must not re-rank by pinned or internal. Use only this helper to restore
 * order after local dedup / mapping, or when filtering by stars (order preserved among kept rows).
 */

/**
 * @template T
 * @param {T[]} rows
 * @returns {T[]}
 */
export function sortByServerHrOrder(rows) {
  if (!Array.isArray(rows) || rows.length === 0) {
    return Array.isArray(rows) ? [...rows] : [];
  }
  if (!rows.some((r) => r && r._hr_sort_index != null)) {
    return [...rows];
  }
  return [...rows].sort(
    (a, b) => Number(a._hr_sort_index ?? 1e9) - Number(b._hr_sort_index ?? 1e9)
  );
}
